import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const getPriceBands = (priceSchemeId: string, searchParam?: string) => {
  const searchParams = new URLSearchParams();
  if (searchParam && searchParam.trim() !== '') {
    searchParams.append('name', searchParam);
  }
  return fetch(`${API_URL}/pricing/price-bands?${searchParams.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });
};
